/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */

import {
  USER_ASSESSMENT_REQUEST,
  USER_ASSESSMENT_SUCCESS,
  USER_ASSESSMENT_FAILURE,
  USER_ASSESSMENT_PRE_SIGNED_URL_REQUEST,
  USER_ASSESSMENT_PRE_SIGNED_URL_SUCCESS,
  USER_ASSESSMENT_PRE_SIGNED_URL_FAILURE,
  CREATE_ASSESSMENT_STEP_REQUEST,
  CREATE_ASSESSMENT_STEP_SUCCESS,
  CREATE_ASSESSMENT_STEP_FAILURE,
  GET_LAST_ASSESSMENT_REQUEST,
  GET_LAST_ASSESSMENT_SUCCESS,
  GET_LAST_ASSESSMENT_FAILURE,
  GET_ASSESSMENT_SUMMARY_REQUEST,
  GET_ASSESSMENT_SUMMARY_SUCCESS,
  GET_ASSESSMENT_SUMMARY_FAILURE,
  LIST_INTAKE_FORM_REQUEST,
  LIST_INTAKE_FORM_SUCCESS,
  LIST_INTAKE_FORM_FAILURE,
  CREATE_INTAKE_FORM_QUESTION_REQUEST,
  CREATE_INTAKE_FORM_QUESTION_SUCCESS,
  CREATE_INTAKE_FORM_QUESTION_FAILURE,
  GET_USER_INTAKE_QUESTIONS_REQUEST,
  GET_USER_INTAKE_QUESTIONS_SUCCESS,
  GET_USER_INTAKE_QUESTIONS_FAILURE,
  GET_USER_INTAKE_CIRCUIT_REQUEST,
  GET_USER_INTAKE_CIRCUIT_SUCCESS,
  GET_USER_INTAKE_CIRCUIT_FAILURE,
  GET_USER_ASSESSMENT_CIRCUIT_REQUEST,
  GET_USER_ASSESSMENT_CIRCUIT_SUCCESS,
  GET_USER_ASSESSMENT_CIRCUIT_FAILURE,
  CREATE_SINGLE_POSE_ASSSESSMENT_REQUEST,
  CREATE_SINGLE_POSE_ASSSESSMENT_SUCCESS,
  CREATE_SINGLE_POSE_ASSSESSMENT_FAILURE,
  RESET_SINGLE_ASSESSMENT_REPORT,
  GET_ASSESSMENT_DATA_REQUEST,
  GET_ASSESSMENT_DATA_SUCCESS,
  GET_ASSESSMENT_DATA_FAILURE,
  UPDATE_PROGRAM_DETAILS_REQUEST,
  UPDATE_PROGRAM_DETAILS_SUCCESS,
  UPDATE_PROGRAM_DETAILS_FAILURE,
} from "./types";
import api from "../utils/api";
import apiAi from "../utils/apiAi";
import { setAlert } from "./alert";
import { getAssessmentErrorDetailsFromPayload } from "../utils/assessmentErrorMapper";

export const getAssessment = () => async (dispatch) => {
  try {
    dispatch({ type: USER_ASSESSMENT_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get(
      "assessments?is_paginate=0&order=asc&order-column=order_no&is_active_only=10",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    dispatch({
      type: USER_ASSESSMENT_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: USER_ASSESSMENT_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getAssessmentPresignedUrl =
  (fileType, fileName, folder_path) => async (dispatch) => {
    try {
      dispatch({
        type: USER_ASSESSMENT_PRE_SIGNED_URL_REQUEST,
      });
      let token = localStorage.getItem("token");
      const res = await api.get(
        "get-s3-token-updated?file_type=" +
          fileType +
          "&file_name=" +
          fileName +
          "&folder_path=" +
          folder_path,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      dispatch({
        type: USER_ASSESSMENT_PRE_SIGNED_URL_SUCCESS,
        payload: res.data.data,
      });
    } catch (err) {
      const msg = err && err.response ? err.response.data.message : null;
      if (msg) {
        dispatch(setAlert(msg, "danger"));
      }
      dispatch({
        type: USER_ASSESSMENT_PRE_SIGNED_URL_FAILURE,
      });
    }
  };
//create assessment step
export const createAssessmentStep = (payload, fileType) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ASSESSMENT_STEP_REQUEST });
    let token = localStorage.getItem("token");
    const res = await api.post("/create-assessment-step", payload, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: CREATE_ASSESSMENT_STEP_SUCCESS,
      payload: res.data,
    });

    let msg = res.data.message;
    if (fileType != "none") {
      dispatch(setAlert(msg, "success"));
    }
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: CREATE_ASSESSMENT_STEP_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getLastAssessment = (userId) => async (dispatch) => {
  try {
    dispatch({ type: GET_LAST_ASSESSMENT_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get("get-last-assessment/" + userId, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: GET_LAST_ASSESSMENT_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_LAST_ASSESSMENT_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getAssessmentSummary = (userId) => async (dispatch) => {
  try {
    dispatch({ type: GET_ASSESSMENT_SUMMARY_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get("get-assessment-summary/" + userId, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: GET_ASSESSMENT_SUMMARY_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_ASSESSMENT_SUMMARY_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getIntakeFormQuestions = () => async (dispatch) => {
  try {
    dispatch({ type: LIST_INTAKE_FORM_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get(
      "intake-forms?is_paginate=0&order=asc&order-column=order_no",
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    dispatch({
      type: LIST_INTAKE_FORM_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: LIST_INTAKE_FORM_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

//create intake form question
export const createIntakeFormQuestion = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_INTAKE_FORM_QUESTION_REQUEST });
    let token = localStorage.getItem("token");
    const res = await api.post("/user-intake-questions", payload, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: CREATE_INTAKE_FORM_QUESTION_SUCCESS,
      payload: res.data,
    });

    let msg = res.data.message;
    dispatch(setAlert(msg, "success"));
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: CREATE_INTAKE_FORM_QUESTION_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getUserIntakeFormQuestions = (circuit) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_INTAKE_QUESTIONS_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get(
      `user-intake-questions?is_paginate=0&order=asc&order-column=id&circuit=${circuit}`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    dispatch({
      type: GET_USER_INTAKE_QUESTIONS_SUCCESS,
      payload: res.data.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_USER_INTAKE_QUESTIONS_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getUserIntakeCircuit = () => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_INTAKE_CIRCUIT_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get("get-intake-circuit", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: GET_USER_INTAKE_CIRCUIT_SUCCESS,
      payload: res?.data?.data?.currentCircuit,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_USER_INTAKE_CIRCUIT_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const getUserAssessmentCircuit = () => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_ASSESSMENT_CIRCUIT_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get("get-assessment-circuit", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: GET_USER_ASSESSMENT_CIRCUIT_SUCCESS,
      payload: res?.data?.data?.currentCircuit,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_USER_ASSESSMENT_CIRCUIT_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const createSinglePose = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_SINGLE_POSE_ASSSESSMENT_REQUEST });
    const res = await apiAi.post("/single-pose/", payload);

    dispatch({
      type: CREATE_SINGLE_POSE_ASSSESSMENT_SUCCESS,
      payload: res.data,
    });

    // let msg = res.data.message
    // dispatch(setAlert(msg, 'success'))
  } catch (err) {
    const responseData = err?.response?.data;
    let msg = "";

    if (responseData?.error || responseData?.aiResponse?.error || responseData?.code) {
      const mappedError = getAssessmentErrorDetailsFromPayload(responseData);
      msg = mappedError.message;
    } else if (responseData?.message) {
      msg = responseData.message;
    } else if (err.message) {
      msg = err.message; // This catches network errors like "Network Error"
    }

    dispatch({ type: CREATE_SINGLE_POSE_ASSSESSMENT_FAILURE });
    dispatch(setAlert(msg, "danger"));

    const wrappedError = new Error(msg || "Failed to analyze image");
    wrappedError.isUserAlertShown = true;
    wrappedError.rawResponse = responseData || null;
    throw wrappedError;
  }
};

export const getAssessmentsData = (userId) => async (dispatch) => {
  try {
    dispatch({ type: GET_ASSESSMENT_DATA_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.get("get-assessments-data/" + userId, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: GET_ASSESSMENT_DATA_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: GET_ASSESSMENT_DATA_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const updateProgramDetails = (userId, payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PROGRAM_DETAILS_REQUEST });
    const token = localStorage.getItem("token");
    const res = await api.put("users/" + userId, payload, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    dispatch({
      type: UPDATE_PROGRAM_DETAILS_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const msg = err.response.data.message;
    dispatch({ type: UPDATE_PROGRAM_DETAILS_FAILURE });
    dispatch(setAlert(msg, "danger"));
  }
};

export const resetSingleAssessmentReport = () => ({
  type: RESET_SINGLE_ASSESSMENT_REPORT,
});
